import { render, staticRenderFns } from "./AssortmentAnalysisDetail.vue?vue&type=template&id=600fa45c&"
import script from "./AssortmentAnalysisDetail.vue?vue&type=script&lang=js&"
export * from "./AssortmentAnalysisDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports